export default "__VITE_ASSET__DAb8e5nw__"